//
// Handles archive Student when user clicks "archive" from "options" dropdown
//
import React from 'react'
import { confirm } from "util/confirm";
import archiveMultipleStudents from "controllers/student/archiveMultipleStudents";

export default function (studentsToArchive, cb) {
  let studentWithClass = []
  let confirmText
  let confirmTitle

  studentsToArchive.map((student) => {
    if(student.class_count > 0){
      studentWithClass.push(student.sName)
    }
  })

  if(studentsToArchive.length < 2){
    confirmTitle = __('Archive Student', 'student')
  } else {
    confirmTitle = __('Archive Multiple Students', 'student')
  }

  if(studentWithClass.length > 0){
    if(studentsToArchive.length < 2){
    confirmText = (
      <div>
        <div>{__("Student {student} is currently in class, proceed to archive student?", 'student', {student: studentWithClass.join(', ')})}</div>
      </div>
    )
  }
  else {
    confirmText = (
      <div>
        <div>{__("Students {student} are currently in classes, proceed to archive students?", 'student', {student: studentWithClass.join(', ')})}</div>
      </div>
    )
  }
  } else {
    confirmText = __('Proceed to archive student {student}?', 'student')
  }

	confirm(confirmText, confirmTitle)
    .then(()=>{
      const studentIDs = studentsToArchive.map((student)=>{
        return student.schoolStudentID;
      });

      const schoolId = localStorage.getItem('schoolId');

      archiveMultipleStudents(schoolId, studentIDs)
      .then((res)=>{
        cb(null, res);
      })
      .catch((err)=>{
        cb(err, null);
      });

		})
		.catch((err)=>{
      cb(err)
			console.log(err);
		});
}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/archive-student.js